import { Inject, Injectable } from '@angular/core';
import { ACCOUNTING_REPOSITORY, AccountingRepository } from '@core/repositories/accounting.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountingService {
  constructor(
    @Inject(ACCOUNTING_REPOSITORY) protected repository: AccountingRepository
  ) {}

  downloadBalanceInterface(data: any): Observable<any> {
    return this.repository.downloadBalanceInterface(data);
  }

  downloadMasterTransfers(data: any): Observable<any> {
    return this.repository.downloadMasterTransfers(data);
  }

  downloadMovementInterface(data: any): Observable<any> {
    return this.repository.downloadMovementInterface(data);
  }

  downloadTransactionsEvents(data: any): Observable<any> {
    return this.repository.downloadTransactionsEvents(data);
  }

   downloadTransactionsLogEvents(data: any): Observable<any> {
    return this.repository.downloadTransactionsLogEvents(data);
  }

  downloadTotalsCosts(data: any): Observable<any> {
    return this.repository.downloadTotalsCosts(data);
  }

  downloadTotalsCostsSentinel(data: any): Observable<any> {
    return this.repository.downloadTotalsCostsSentinel(data);
  }

  getTypeEvent(): Observable<any> {
    return this.repository.getTypeEvent();
  }
}
